export const USER_SETTINGS_UPDATE_DATA = 'USER_SETTINGS_UPDATE_DATA';
export const USER_SETTINGS_UPDATE_DATA_SUCCESS = 'USER_SETTINGS_UPDATE_DATA_SUCCESS';
export const USER_SETTINGS_UPDATE_DATA_ERROR = 'USER_SETTINGS_UPDATE_DATA_ERROR';
export const USER_SETTINGS_UPDATE_DATA_CLEAN_STATE = 'USER_SETTINGS_UPDATE_DATA_CLEAN_STATE';